import React from 'react';
import ArtifactViewMainContentSignaturesComponentVersionPackageManagerMaven from '~/artifact/components/ArtifactViewMainContentSignaturesComponentVersionPackageManagerMaven';
import ArtifactViewMainContentSignaturesComponentVersionPackageManagerGradle from '~/artifact/components/ArtifactViewMainContentSignaturesComponentVersionPackageManagerGradle';
import ArtifactViewMainContentSignaturesComponentVersionPackageManagerSBT from '~/artifact/components/ArtifactViewMainContentSignaturesComponentVersionPackageManagerSBT';
import ArtifactViewMainContentSignaturesComponentVersionPackageManagerRubyGems from '~/artifact/components/ArtifactViewMainContentSignaturesComponentVersionPackageManagerRubyGems';
import ArtifactViewMainContentSignaturesComponentVersionPackageManagerNPM from '~/artifact/components/ArtifactViewMainContentSignaturesComponentVersionPackageManagerNPM';
import ArtifactViewMainContentSignaturesComponentVersionPackageManagerYarn from '~/artifact/components/ArtifactViewMainContentSignaturesComponentVersionPackageManagerYarn';
import ArtifactViewMainContentSignaturesComponentVersionPackageManagerBower from '~/artifact/components/ArtifactViewMainContentSignaturesComponentVersionPackageManagerBower';
import ArtifactViewMainContentSignaturesComponentVersionPackageManagerPyPI from '~/artifact/components/ArtifactViewMainContentSignaturesComponentVersionPackageManagerPyPI';
import ArtifactViewMainContentSignaturesComponentVersionPackageManagerCocoaPods from '~/artifact/components/ArtifactViewMainContentSignaturesComponentVersionPackageManagerCocoaPods';
import ArtifactViewMainContentSignaturesComponentVersionPackageManagerHeader from '~/artifact/containers/ArtifactViewMainContentSignaturesComponentVersionPackageManagerHeader';
type ArtifactViewMainContentSignaturesComponentVersionDetailsCoordinatesProps = {
  activeManager?: string;
  component: object;
  version: object;
};
const ArtifactViewMainContentSignaturesComponentVersionDetailsCoordinates: React.SFC<
  ArtifactViewMainContentSignaturesComponentVersionDetailsCoordinatesProps
> = props => {
  let component = props.component,
    version = props.version,
    language = component.languageType || '',
    coordinateType = component.coordinateType || '',
    activeManager = props.activeManager,
    packageManagerElementLookup,
    packageManagerElement,
    headerElements = [];
  packageManagerElementLookup = {
    maven: (
      <ArtifactViewMainContentSignaturesComponentVersionPackageManagerMaven
        component={component}
        version={version}
      />
    ),
    gradle: (
      <ArtifactViewMainContentSignaturesComponentVersionPackageManagerGradle
        component={component}
        version={version}
      />
    ),
    sbt: (
      <ArtifactViewMainContentSignaturesComponentVersionPackageManagerSBT
        component={component}
        version={version}
      />
    ),
    gem: (
      <ArtifactViewMainContentSignaturesComponentVersionPackageManagerRubyGems
        component={component}
        version={version}
      />
    ),
    npm: (
      <ArtifactViewMainContentSignaturesComponentVersionPackageManagerNPM
        component={component}
        version={version}
      />
    ),
    yarn: (
      <ArtifactViewMainContentSignaturesComponentVersionPackageManagerYarn
        component={component}
        version={version}
      />
    ),
    bower: (
      <ArtifactViewMainContentSignaturesComponentVersionPackageManagerBower
        component={component}
        version={version}
      />
    ),
    pypi: (
      <ArtifactViewMainContentSignaturesComponentVersionPackageManagerPyPI
        component={component}
        version={version}
      />
    ),
    cocoapods: (
      <ArtifactViewMainContentSignaturesComponentVersionPackageManagerCocoaPods
        component={component}
        version={version}
      />
    ),
  };
  packageManagerElement = packageManagerElementLookup[activeManager];
  if (language.toLowerCase() === 'java') {
    headerElements = (
      <div className="grid col-2-5 flex flex--justify-content--space-between phone--col-1-1">
        <div className="inline-block pl">
          <ArtifactViewMainContentSignaturesComponentVersionPackageManagerHeader
            manager="maven"
            text="Maven"
            activeManager={activeManager}
          />
        </div>
        <div className="inline-block">
          <ArtifactViewMainContentSignaturesComponentVersionPackageManagerHeader
            manager="gradle"
            text="Gradle"
            activeManager={activeManager}
          />
        </div>
        <div className="inline-block">
          <ArtifactViewMainContentSignaturesComponentVersionPackageManagerHeader
            manager="sbt"
            text="sbt"
            activeManager={activeManager}
          />
        </div>
      </div>
    );
  } else if (language.toLowerCase() === 'ruby') {
    headerElements = (
      <div className="grid col-1-5 phone--col-1-1">
        <div className="grid__item flex">
          <ArtifactViewMainContentSignaturesComponentVersionPackageManagerHeader
            manager="gem"
            text="Ruby Gems"
            activeManager={activeManager}
          />
        </div>
      </div>
    );
  } else if (language.toLowerCase() === 'python') {
    headerElements = (
      <div className="grid col-1-5 phone--col-1-1">
        <div className="grid__item flex">
          <ArtifactViewMainContentSignaturesComponentVersionPackageManagerHeader
            manager="pypi"
            text="PyPI"
            activeManager={activeManager}
          />
        </div>
      </div>
    );
  } else if (language.toLowerCase() === 'js' && coordinateType.toLowerCase() === 'npm') {
    headerElements = (
      <div className="grid col-1-5 flex flex--justify-content--space-between phone--col-1-1">
        <div className="inline-block pl">
          <ArtifactViewMainContentSignaturesComponentVersionPackageManagerHeader
            manager="npm"
            text="Npm"
            activeManager={activeManager}
          />
        </div>
        <div className="inline-block pl">
          <ArtifactViewMainContentSignaturesComponentVersionPackageManagerHeader
            manager="yarn"
            text="Yarn"
            activeManager={activeManager}
          />
        </div>
      </div>
    );
  } else if (language.toLowerCase() === 'js' && coordinateType.toLowerCase() === 'bower') {
    headerElements = (
      <div className="grid col-1-5 phone--col-1-1">
        <div className="grid__item flex">
          <ArtifactViewMainContentSignaturesComponentVersionPackageManagerHeader
            manager="bower"
            text="bower"
            activeManager={activeManager}
          />
        </div>
      </div>
    );
  }
  return (
    <div className="grid pt-">
      <div className="grid__item col-1-1 pt-">
        <div className="grid bo--1 border-color--muted font--12 p-">
          Coordinates are used by agents when they build projects. The agent monitors the
          coordinates used to request libraries after the dependencies resolution process has
          completed and requrements have been satisfied. The vast majority of dependencies are never
          actually written in the build files but rather pulled in as part of the build step in what
          are called <em>transitive dependencies</em>.
        </div>
      </div>
      <div className="grid__item col-1-1 pt">{headerElements}</div>
      <div className="grid__item col-1-1 pt">{packageManagerElement}</div>
    </div>
  );
};
export default ArtifactViewMainContentSignaturesComponentVersionDetailsCoordinates;
